<template>
    <div>
        <!-- Modal Autorizar Solicitação -->
        <div class="modal fade" id="solicAutorizaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Autorizar Solicitação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="solic">
                            <div class="alert alert-info d-flex justify-content-between">
                                <div>
                                    <div v-if="solic.fl_solic_compra">
                                        <strong>Solicitação de Compra</strong>
                                    </div>

                                    <div v-if="solic.fl_transfer && solic.destino">
                                        De: <strong>{{ solic.destino.search }}</strong>
                                    </div>
                                    <div v-else-if="solic.centro_custo">
                                        De: <strong>{{ solic.centro_custo.search }}</strong>
                                    </div>
                                    <div>
                                        Para: <strong>{{ solic.local.search }}</strong>
                                    </div>

                                    <div>
                                        Solicitante: <strong>{{ solic.usuario.st_login }}</strong>
                                    </div>

                                    <div v-if="solic.st_observacao">
                                        Obs: <span>{{ solic.st_observacao }}</span>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <div>
                                        #{{ solic.id_estoque_solicitacao }}
                                    </div>
                                    <div>
                                        {{ $util.getFormatDate(solic.dt_solicitacao) }} {{ solic.dt_solicitacao.slice(11,16) }}
                                    </div>
                                </div>
                            </div>
                                    
                            <table class="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Id</th>
                                        <th>Descrição</th>
                                        <th class="text-right">Quantidade</th>
                                        <th></th>
                                        <th class="text-right">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, iix) in solic.items" :key="iix" :class="!item.fl_ativo ? 'table-secondary' : ''">
                                        <td width="3%">
                                            <input type="checkbox" v-model="item.fl_ativo">
                                        </td>
                                        <td width="12%">#{{ item.id_estoque_item }}</td>
                                        <td width="40%">{{ item.item.search }}
                                            <div class="small text-muted" v-if="item.st_observacao">
                                                {{ item.st_observacao }}
                                            </div>
                                        </td>
                                        <td class="text-right" width="15%">
                                            <az-input
                                                sizing="sm"
                                                placeholder="Qtde..."
                                                type="number"
                                                min="1"
                                                max="9999999999"
                                                v-model="item.in_quantidade" />
                                        </td>
                                        <td width="15%">{{ item.item.st_unidade_estoque }}</td>
                                        <td class="text-right" width="15%">
                                            <span v-if="item.item.ultima_entrada">
                                                {{ $util.formatMoeda(item.item.ultima_entrada.dc_valor * item.in_quantidade) }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colspan="5">Total:</th>
                                        <th class="text-right">
                                            {{ $util.formatMoeda(valor_total) }}
                                        </th>
                                    </tr>
                                </tfoot>
                            </table>

                            <template v-if="true">

                                <selecao-material 
                                    ref="selecmat" 
                                    :consumo_paciente="solic.fl_paciente ? true : false"
                                    @selecionado="incluir_item" 
                                    :id_estoque_local="solic.id_estoque_local" 
                                    :infoqt="true" 
                                    :blocklote="true" 
                                    :kits="false" />

                                <br><br><br><br><br><br><br><br><br><br><br><br>

                            </template>
                        </div>

                        <pre v-if="false">{{ solic }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="autorizar()">Autorizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import SelecaoMaterial from './SelecaoMaterial.vue';

export default {
    components: { AzSubmit, AzInput, SelecaoMaterial },

    data() {
        return { 
            solic: null, 
            ver_valores: true, 
            sempre_ver_saldos: true, 
        }       
    },
    
    computed: { 
        valor_total: function () { 
            if ( !this.solic || !this.solic.items ) 
                return 0;

            let total = 0;

            for ( let item of this.solic.items ) { 
                if ( item.fl_ativo && item.item && item.item.ultima_entrada ) { 
                    total += parseFloat( item.item.ultima_entrada.dc_valor * item.in_quantidade );
                }
            }

            return total;
        }
    },  

    methods: { 
        abrir(id_estoque_solicitacao) { 
            this.solic = null;

            this.$util.load(this, { 
                service: 'estoque_solicitacoes',
                func: 'show',
                parms: { 
                    id: id_estoque_solicitacao, 
                    atendimento: true, 
                    autorizacao: true,
                },
                loadTo: res => { 
                    this.solic = res;
                }
            });

            $('#solicAutorizaModal').modal('show');
        },

        autorizar() { 
            if (!this.solic) 
                return;

            this.$util.atualizar(this, { 
                service: 'estoque',
                func: 'autorizar_solicitacao',
                dados: { 
                    id_estoque_solicitacao: this.solic.id_estoque_solicitacao, 
                    items: this.solic.items
                },
                modal: 'solicAutorizaModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        incluir_item(novo) { 
            if ( !novo )
                return;

            let busca = this.solic.items.find(item => item.fl_ativo 
                && item.item.id_estoque_item == novo.id_estoque_item
                && ( !_.get(novo, 'lote.item') || _.get(item, 'lote.st_lote') == _.get(novo, 'lote.item.st_lote') ) 
                && !item.st_observacao
            );

            if ( busca ) { 
                busca.in_quantidade = parseInt(busca.in_quantidade) + parseInt( novo.quantidade ? novo.quantidade : 1 );
                return; 
            }

            let novoitem = { 
                id_estoque_solicitacao: this.solic.id_estoque_solicitacao, 
                id_estoque_item: novo.id_estoque_item, 
                id_estoque_item_kit: novo.id_estoque_item_kit, 
                item: novo, 
                in_quantidade: novo.quantidade ? novo.quantidade : 1,
                id_receita_medicamento: novo.id_receita_medicamento ? novo.id_receita_medicamento : null,
                fl_pendente: true, 
                st_observacao: "", 
                fl_ativo: true, 
                mav: false, 
                fl_block_cobranca: novo.fl_block_cobranca ? novo.fl_block_cobranca : false,
                lote: _.get(novo, 'lote.item'), 
                horarios: _.get(novo, 'horarios'),
                saldo: { 
                    loading: true,
                },
            };

            this.solic.items.push(novoitem);

            if ( novoitem && novoitem.saldo ) {  

                this.$util.loadItem(this, { 
                    service: "estoque_items",
                    id: novo.id_estoque_item, 
                    parms: { 
                        saldos: true, 
                        id_estoque_local: this.solic.id_estoque_local,
                        id_unidade_operacao: ( this.solic && this.solic.centro_custo && this.solic.centro_custo.id_unidade_operacao ) ? this.solic.centro_custo.id_unidade_operacao : null,
                        num_lote: _.get(novo, 'lote.item.st_lote'), 
                        reservas: true, 
                        componentes: true, 
                        mav: true, 
                        id_receita_medicamento: _.get(novo, 'id_receita_medicamento'),
                    }
                })
                .then(res => { 
                    if ( !res.saldo ) { 
                        novoitem.saldo = { 
                            qtd: 0, 
                        };
                        novoitem.reservado = 0;
                    } else { 
                        novoitem.saldo = res.saldo;
                        novoitem.reservado = res.reservado ? res.reservado : 0;
                    }

                    if ( res.ultima_entrada ) { 
                        novoitem.item.ultima_entrada = res.ultima_entrada;
                    }

                    if ( res.mav ) { 
                        novoitem.item.mav = res.mav;
                    }

                    this.$forceUpdate();
                });
                
            }

        },

    }

}
</script>
